<template>
<div>
<div class="col-6">
  <h4 style="color:black" class="text-left mr-3">Ricarico  <span class="badge badge-danger">{{markUp}}</span></h4>
</div>
</div>
</template>

<script>


  export default {
    props:['price1','price2'],
     components: {},
    data () {
      return {
        markUp : 0
      }
    },
    
  
    created () 
    {
      this.setMarkUp()
    },
    methods: 
    {
    setMarkUp()
    {
      
     var markUp = this.price2 / this.price1
     if(this.price1 > 0 && this.price2 > 0)
     {
      this.markUp = markUp.toFixed(2)
     }    
      
      
    },
    

      
      

      
      

    }
  }
</script>
<style scoped>

h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
</style>
